(() => {
  // app/scripts/related-products.js
  var RelatedProducts = class extends HTMLElement {
    constructor() {
      super();
      this.sliderContainer = this.querySelector(".js-slider");
      this.productId = this.getAttribute("data-product-id");
      this.limit = this.getAttribute("data-limit") || "8";
    }
    async connectedCallback() {
      if (!this.productId || !this.sliderContainer)
        return;
      const url = `${Shopify.routes.root}recommendations/products?section_id=related-products-results&product_id=${encodeURIComponent(this.productId)}&limit=${encodeURIComponent(this.limit)}&intent=related`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Related products failed: ${response.status} ${response.statusText}`);
      }
      const html = await response.text();
      const container = document.createElement("div");
      container.innerHTML = html;
      const slides = [...container.querySelectorAll(".swiper-slide")];
      if (!slides.length)
        return;
      this.preserveParentCollectionContext(slides);
      this.sliderContainer.append(...slides);
      this.classList.remove("hidden");
      window.themeLivePrice?.refresh(this.sliderContainer);
    }
    preserveParentCollectionContext(slides) {
      const parentCollectionHandle = new URLSearchParams(window.location.search).get("pc");
      if (!parentCollectionHandle)
        return;
      slides.forEach((slide) => {
        slide.querySelectorAll("a[href]").forEach((link) => {
          const url = new URL(link.getAttribute("href"), window.location.origin);
          if (url.origin !== window.location.origin)
            return;
          url.searchParams.set("pc", parentCollectionHandle);
          link.href = `${url.pathname}${url.search}${url.hash}`;
        });
      });
    }
  };
  customElements.define("related-products", RelatedProducts);
})();
